import React from 'react'
import { FaFacebookSquare,FaInstagramSquare,FaPinterestSquare,FaLinkedin,FaChevronRight,FaPhoneSquareAlt,FaMailBulk} from 'react-icons/fa';

export const Footer = () => {
  return (
    <section className='main-footer'  id='mainfooter'>
        <footer className='footer m-top' id='footer'>
            <div className="container">
                 <div className="flex spce-btwn align-center">
                       <ul>
                          <li><img src="./Assets/img/footer-logo-3.png" alt="footer-logo"/></li>
                          <li>Techsaga Corporations is bristled on the foundation of multidisciplinary team inherited with the proven track record and eminent talent.</li>
                          <li>
                              <ul className='social-links'>
                                  <li><a href="/"><FaFacebookSquare/></a></li>
                                  <li><a href="/"><FaInstagramSquare/></a></li>
                                  <li><a href="/"><FaPinterestSquare/></a></li>
                                  <li><a href="/"><FaLinkedin/></a></li>
                              </ul>
                          </li>
                       </ul>
                       <ul className='itservice'>
                          <h3> IT Services</h3>
                          <li><FaChevronRight/> Software Development</li>
                          <li><FaChevronRight/> Web Development</li>
                          <li><FaChevronRight/> Analytic Solutions</li>
                          <li><FaChevronRight/> Analytic Solutions</li>
                          <li><FaChevronRight/> Cloud and DevOps</li>
                          <li><FaChevronRight/> Product Design</li>
                       </ul>
                       <ul className='ftr-contact'>
                          <h3>Contact Us</h3>
                          <li>106, Anniversary Avenue, Wyndham Vale - 3024. Victoria, Australia.</li>
                          <li>
                              <ul className='flex'>
                                  <li><FaPhoneSquareAlt/></li>
                                  <li>
                                      <div>
                                        <h5>Phone:</h5> 
                                        +123 34598768
                                      </div>
                                  </li>  
                              </ul>
                          </li>
                          <li>
                          <ul className='flex'>
                                  <li><FaMailBulk/></li>
                                  <li>
                                      <div>
                                        <h5>Email:</h5> 
                                        techsaga@.co.in
                                      </div>
                                  </li>  
                              </ul>
                          </li>  
                       </ul>
                       <ul className='subscribe'>
                           <h3>Subscribe to Newsletter</h3>
                              <li>Join our subscribers list to get the latest news and special offers.</li>
                              <li><input type="your email" /></li>
                              <li><a href="/" className='glbl-btn'>Subscribe Now</a> </li>
                       </ul>
                 </div>
                 <div className="partners">
                     <div className="flex spce-btwn align-center">
                     <div className="part-box">
                              <a href="/"><img src="./Assets/img/Picture2.png" alt="iaf-partner" /></a>
                          </div>
                          <div className="part-box">
                              <a href="/"><img src="./Assets/img/rm-certified.png" alt="iaf-partner" /></a>
                          </div>
                          <div className="part-box">
                              <a href="/"><img src="./Assets/img/EMC-logo.png" alt="iaf-partner" /></a>
                          </div>
                          <div className="part-box">
                              <a href="/"><img src="./Assets/img/google-partner.png" alt="iaf-partner" /></a>
                          </div>
                          <div className="part-box">
                              <a href="/"><img src="./Assets/img/ias-certified.png" alt="iaf-partner" /></a>
                          </div>
                          <div className="part-box">
                              <a href="/"><img src="./Assets/img/icab-certified.png" alt="iaf-partner" /></a>
                          </div>
                          <div className="part-box">
                              <a href="/"><img src="./Assets/img/shpify.jpg" alt="iaf-partner" /></a>
                          </div>
                          <div className="part-box">
                          <a href="/"><img src="./Assets/img/iaf-par.png" alt="iaf-partner" /></a>
                          </div>  
                          <div className="part-box">
                              <a href="/"><img src="./Assets/img/egac-certified.png" alt="iaf-partner" /></a>
                          </div>
                     </div>
                 </div>
            </div>
            <div className="copyright">
                <div className="container">
                <div className="flex spce-btwn align-center">
                        <div className="left">
                            <p>© 2022 All Rights Reserved.</p>
                        </div>
                        <div className="right">
                           <ul className='flex align-center spce-'>
                            <li><a href="/">Home</a></li>
                            <li><a href="/">About</a></li>
                            <li><a href="/">Blog</a></li>
                            <li><a href="/">Services</a></li>
                           </ul>
                        </div>
                     </div> 
                 </div>        
            </div>
    </footer>
    </section>
  )
}
